import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { ListsIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFullUrl } from 'hubspot-url-utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FaceNavInviteYourTeam = ({
  portalId
}) => {
  if (!portalId) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    borderColor: "border-core-default",
    paddingBlock: "100",
    paddingInline: "400",
    children: /*#__PURE__*/_jsx(Link, {
      href: `${getFullUrl('app')}/settings/${portalId}/users/add?via=account-menu`,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          color: "icon-core-subtle",
          icon: ListsIcon,
          size: "500"
        }), /*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.inviteLink"
          })
        })]
      })
    })
  });
};